export const twoFixedDigit = (value: number) => Number(value.toFixed(2));
